import { ca } from '@cian/analytics';

export const trackSendFormClick = (draft_id: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'click',
    label: 'send',
    page: {
      extra: {
        draft_id,
      },
    },
  });
};
